export const baitTranslations = {
  "Minhoca": {
    name: {
      en: "Worm",
      es: "Lombriz",
      zh: "蚯蚓"
    },
    description: {
      en: "Basic bait for beginners",
      es: "Cebo básico para principiantes",
      zh: "初学者的基础诱饵"
    }
  },
  "Grilo": {
    name: {
      en: "Cricket",
      es: "Grillo",
      zh: "蟋蟀"
    },
    description: {
      en: "Better quality bait",
      es: "Cebo de mejor calidad",
      zh: "高质量鱼饵"
    }
  },
  "Camarão": {
    name: {
      en: "Shrimp",
      es: "Camarón",
      zh: "虾"
    },
    description: {
      en: "Professional bait",
      es: "Cebo para profesionales",
      zh: "专业鱼饵"
    }
  },
  "I.S.C.A 3000": {
    name: {
      en: "B.A.I.T 3000",
      es: "C.E.B.O 3000",
      zh: "饵3000"
    },
    description: {
      en: "A bait developed in Mjolnir's best laboratories",
      es: "Un cebo desarrollado en los mejores laboratorios de Mjolnir",
      zh: "在姆乔尔尼尔最好的实验室开发的鱼饵"
    }
  }
};
